let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gH0BH")).then(() => parcelRequire('iF4op'));